import TemplateState from "@/modules/conversation-template";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const ConversationsResolver = async function (to: Route, from: Route, next: Function) {
	const templateModule = getModule(TemplateState);
	const actions: Promise<void>[] = [];

	if (!templateModule.conversations.length) {
		actions.push(templateModule.fetchConversation());
	}

	await Promise.all(actions);
	next();
};
